import React from 'react';
import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { AutoImage } from './auto-image';


export const HorizontalArticle = styled.div`
  display: flex;
  gap: 2rem;
  @media (max-width: 40rem){
    flex-direction: column;
  }
`
export const HorizontalArticleWithLargeGap = styled(HorizontalArticle)`
  gap: 4rem;
`
export const HorizontalArticleTextContainer = styled.div`
  flex: 0 0 16rem;
  text-align: justify;
  position: relative;
  @media (max-width: 40rem){
    order: 1;
    padding: 0 1rem;
    flex: 0 0 auto;
  }
`
export const HorizontalArticleTitle = styled.div`
  font-size: 1.25rem;
  line-height: 1.75;
  font-weight: 700;
  letter-spacing: 0.05em;
  & + & {
    margin-top: 0.5rem;
    @media (max-width: 40rem){
      margin-top: 0;
    }
  }
  small {
    font-size: 0.8em;
  }
`
export const HorizontalArticleTitleWithColor = styled(HorizontalArticleTitle)`
  --line-height: calc(1.25rem * 1.75);
  --offset: -0.25rem;
  background-image: linear-gradient(to bottom, transparent calc(var(--line-height) - 0.175rem + var(--offset)), #9c91bd calc(var(--line-height) + var(--offset)), transparent calc(var(--line-height) + var(--offset)));
  background-repeat: repeat-y;
  background-size: 100% var(--line-height);
  color: #9c91bd;
  @media (max-width: 40rem){
    br {
      display: none;
    }
  }
`
export const HorizontalArticleText = styled.div`
  font-size: 0.9rem;
  line-height: 2;
  margin-top: 1rem;
  font-weight: 500;
  z-index: 1;
  position: relative;
`


const ImageContainer = styled.div`
  position: relative;
  flex: 1 1 0;
  img {
    display: block;
    width: 100%;
    height: auto;
  }
`
const Decoration = styled.div`
  position: absolute;
  bottom: 1rem;
  @media (max-width: 40rem){
    bottom: -2rem;
  }
  img {
    width: 8rem;
    height: auto;
    display: block;
    @media (max-width: 40rem){
      height: 5rem;
      width: auto;
    }
  }
`
const LeftDecoration = styled(Decoration)`
  left: -2.5rem;
  @media (max-width: 40rem){
    left: 0;
  }
`
const RightDecoration = styled(Decoration)`
  right: -2.5rem;
  @media (max-width: 40rem){
    right: 0;
  }
`

type HorizontalArticleImageContainerProps = {
  left?: string
  right?: string
}
export const HorizontalArticleImageContainer: FunctionComponent<HorizontalArticleImageContainerProps> = ({children, left, right}) => {
  return <ImageContainer>
    {children}
    {
      left &&
      <LeftDecoration>
        <AutoImage src={left} />
      </LeftDecoration>
    }
    {
      right &&
      <RightDecoration>
        <AutoImage src={right} />
      </RightDecoration>
    }
  </ImageContainer>
}